export default __webpack_public_path__ + "./images/tv.b12eaee8.png";